import { useOutletContext } from "react-router";

import { Box, Button, Stack, Typography } from "@mui/material";
import { ClientContent } from "@shared";

import { ClientDetailResponse } from "@/api";
import { useTranslation } from "@/translations";

import { GoalsResultsRow } from "./components/GoalsResultsRow";
import { useGoalsResults } from "./hooks/useGoalsResults";

export function GoalsResultsView() {
  const client = useOutletContext<ClientDetailResponse>();
  const { t } = useTranslation();

  const { formik, goalOptionStrings, handleAddRow, handleDeleteRow } = useGoalsResults(client.clientId);

  return (
    <ClientContent formik={formik}>
      <Stack flex={1} sx={{ maxHeight: "100%", overflowY: "auto", bgcolor: "background.paper" }}>
        <Typography sx={{ p: 2, pb: 1 }} variant="h5">
          {t("clients.goalsResults.title")}
        </Typography>

        <Stack sx={{ gap: 2, p: 2 }}>
          {formik.values.rows.map((row, index) => (
            <GoalsResultsRow
              key={row.goalId ?? `new-${index}`}
              formik={formik}
              index={index}
              goalOptions={goalOptionStrings}
              onDelete={() => handleDeleteRow(index)}
            />
          ))}

          <Box display="flex" justifyContent="flex-end">
            <Button variant="outlined" size="small" onClick={handleAddRow}>
              {t("clients.goalsResults.addButton")}
            </Button>
          </Box>
        </Stack>
      </Stack>
    </ClientContent>
  );
}

export default GoalsResultsView;
